import { AdminConfig } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

AdminConfig.useAccount({
  accountForm: () => import('./AccountForm'),
  textMenuSettings: $vm => $vm.$t('account.settings'),
})

messageGroups.push('account')
